import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { AvatarWithLabel, Box, Typography } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { RequiredApproverCard } from './RequiredApproverCard';
export function AdvancedApprovalCheckPreview(props) {
    const { summary, approvers, isApprovalRequired } = props;
    return (<Box flexDirection="column" gap="xl">
      <Box flexDirection="column" gap="md">
        <AvatarWithLabel solid size="sm" appearance="dark" title={t({ message: 'PLAI', comment: 'Document approval check - PLAI' })}>
          <Falcon icon="sparkles"/>
        </AvatarWithLabel>
        <Typography $fontSize="small" $appearance="300">
          {summary}
        </Typography>
      </Box>

      {isApprovalRequired && (<Box flexDirection="column" gap="md">
          <Box alignItems="center" gap="md">
            <Falcon icon="eye" $color="semantic.foreground.secondary"/>
            <Typography $fontSize="tiny" $appearance="200">
              <Trans comment="Document approval check - Approval required by">Approval required by</Trans>
            </Typography>
          </Box>
          {approvers.map((approver) => (<RequiredApproverCard key={approver.id} {...approver}/>))}
        </Box>)}
    </Box>);
}
